import { createContext, useContext } from "react";

const DesignContestEntryContext = createContext(false);

export const DesignContestEntryProvider = DesignContestEntryContext.Provider;

export const useDesignContestEntry = () => useContext(DesignContestEntryContext);
